/* Generated by scripts/process-images.mjs — do not edit. */
import type { MediaAsset } from '../types'

export const mediaAssets = [
  {
    "id": "akihabara-01",
    "folder": "Akihabara",
    "source": "images/Akihabara/Untitled 26.png",
    "width": 720,
    "height": 480,
    "aspectRatio": 1.5,
    "alt": "Akihabara, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/akihabara/image-01-480.webp",
        "avif": "/media/akihabara/image-01-480.avif"
      },
      {
        "width": 720,
        "webp": "/media/akihabara/image-01-720.webp",
        "avif": "/media/akihabara/image-01-720.avif"
      }
    ]
  },
  {
    "id": "akihabara-02",
    "folder": "Akihabara",
    "source": "images/Akihabara/Untitled 27.png",
    "width": 1127,
    "height": 860,
    "aspectRatio": 1.3105,
    "alt": "Akihabara, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/akihabara/image-02-480.webp",
        "avif": "/media/akihabara/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/akihabara/image-02-960.webp",
        "avif": "/media/akihabara/image-02-960.avif"
      },
      {
        "width": 1127,
        "webp": "/media/akihabara/image-02-1127.webp",
        "avif": "/media/akihabara/image-02-1127.avif"
      }
    ]
  },
  {
    "id": "akihabara-03",
    "folder": "Akihabara",
    "source": "images/Akihabara/Untitled 28.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Akihabara, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/akihabara/image-03-480.webp",
        "avif": "/media/akihabara/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/akihabara/image-03-960.webp",
        "avif": "/media/akihabara/image-03-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/akihabara/image-03-1290.webp",
        "avif": "/media/akihabara/image-03-1290.avif"
      }
    ]
  },
  {
    "id": "akihabara-04",
    "folder": "Akihabara",
    "source": "images/Akihabara/Untitled 29.png",
    "width": 1289,
    "height": 860,
    "aspectRatio": 1.4988,
    "alt": "Akihabara, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/akihabara/image-04-480.webp",
        "avif": "/media/akihabara/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/akihabara/image-04-960.webp",
        "avif": "/media/akihabara/image-04-960.avif"
      },
      {
        "width": 1289,
        "webp": "/media/akihabara/image-04-1289.webp",
        "avif": "/media/akihabara/image-04-1289.avif"
      }
    ]
  },
  {
    "id": "akihabara-05",
    "folder": "Akihabara",
    "source": "images/Akihabara/Untitled 30.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Akihabara, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/akihabara/image-05-480.webp",
        "avif": "/media/akihabara/image-05-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/akihabara/image-05-960.webp",
        "avif": "/media/akihabara/image-05-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/akihabara/image-05-1290.webp",
        "avif": "/media/akihabara/image-05-1290.avif"
      }
    ]
  },
  {
    "id": "arashiyama-01",
    "folder": "Arashiyama",
    "source": "images/Arashiyama/Untitled 5.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Arashiyama, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/arashiyama/image-01-480.webp",
        "avif": "/media/arashiyama/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/arashiyama/image-01-960.webp",
        "avif": "/media/arashiyama/image-01-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/arashiyama/image-01-1290.webp",
        "avif": "/media/arashiyama/image-01-1290.avif"
      }
    ]
  },
  {
    "id": "arashiyama-02",
    "folder": "Arashiyama",
    "source": "images/Arashiyama/Untitled 6.png",
    "width": 1024,
    "height": 683,
    "aspectRatio": 1.4993,
    "alt": "Arashiyama, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/arashiyama/image-02-480.webp",
        "avif": "/media/arashiyama/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/arashiyama/image-02-960.webp",
        "avif": "/media/arashiyama/image-02-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/arashiyama/image-02-1024.webp",
        "avif": "/media/arashiyama/image-02-1024.avif"
      }
    ]
  },
  {
    "id": "arashiyama-03",
    "folder": "Arashiyama",
    "source": "images/Arashiyama/Untitled 7.png",
    "width": 1289,
    "height": 860,
    "aspectRatio": 1.4988,
    "alt": "Arashiyama, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/arashiyama/image-03-480.webp",
        "avif": "/media/arashiyama/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/arashiyama/image-03-960.webp",
        "avif": "/media/arashiyama/image-03-960.avif"
      },
      {
        "width": 1289,
        "webp": "/media/arashiyama/image-03-1289.webp",
        "avif": "/media/arashiyama/image-03-1289.avif"
      }
    ]
  },
  {
    "id": "arashiyama-04",
    "folder": "Arashiyama",
    "source": "images/Arashiyama/Untitled 8.png",
    "width": 1288,
    "height": 860,
    "aspectRatio": 1.4977,
    "alt": "Arashiyama, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/arashiyama/image-04-480.webp",
        "avif": "/media/arashiyama/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/arashiyama/image-04-960.webp",
        "avif": "/media/arashiyama/image-04-960.avif"
      },
      {
        "width": 1288,
        "webp": "/media/arashiyama/image-04-1288.webp",
        "avif": "/media/arashiyama/image-04-1288.avif"
      }
    ]
  },
  {
    "id": "arashiyama-05",
    "folder": "Arashiyama",
    "source": "images/Arashiyama/Untitled 9.png",
    "width": 1024,
    "height": 1536,
    "aspectRatio": 0.6667,
    "alt": "Arashiyama, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/arashiyama/image-05-480.webp",
        "avif": "/media/arashiyama/image-05-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/arashiyama/image-05-960.webp",
        "avif": "/media/arashiyama/image-05-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/arashiyama/image-05-1024.webp",
        "avif": "/media/arashiyama/image-05-1024.avif"
      }
    ]
  },
  {
    "id": "fushimi-inari-taisha-01",
    "folder": "Fushimi Inari Taisha",
    "source": "images/Fushimi Inari Taisha/Untitled 11.png",
    "width": 1200,
    "height": 800,
    "aspectRatio": 1.5,
    "alt": "Fushimi Inari Taisha, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/fushimi-inari-taisha/image-01-480.webp",
        "avif": "/media/fushimi-inari-taisha/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/fushimi-inari-taisha/image-01-960.webp",
        "avif": "/media/fushimi-inari-taisha/image-01-960.avif"
      },
      {
        "width": 1200,
        "webp": "/media/fushimi-inari-taisha/image-01-1200.webp",
        "avif": "/media/fushimi-inari-taisha/image-01-1200.avif"
      }
    ]
  },
  {
    "id": "fushimi-inari-taisha-02",
    "folder": "Fushimi Inari Taisha",
    "source": "images/Fushimi Inari Taisha/Untitled 12.png",
    "width": 683,
    "height": 1024,
    "aspectRatio": 0.667,
    "alt": "Fushimi Inari Taisha, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/fushimi-inari-taisha/image-02-480.webp",
        "avif": "/media/fushimi-inari-taisha/image-02-480.avif"
      },
      {
        "width": 683,
        "webp": "/media/fushimi-inari-taisha/image-02-683.webp",
        "avif": "/media/fushimi-inari-taisha/image-02-683.avif"
      }
    ]
  },
  {
    "id": "fushimi-inari-taisha-03",
    "folder": "Fushimi Inari Taisha",
    "source": "images/Fushimi Inari Taisha/Untitled 13.png",
    "width": 739,
    "height": 900,
    "aspectRatio": 0.8211,
    "alt": "Fushimi Inari Taisha, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/fushimi-inari-taisha/image-03-480.webp",
        "avif": "/media/fushimi-inari-taisha/image-03-480.avif"
      },
      {
        "width": 739,
        "webp": "/media/fushimi-inari-taisha/image-03-739.webp",
        "avif": "/media/fushimi-inari-taisha/image-03-739.avif"
      }
    ]
  },
  {
    "id": "fushimi-inari-taisha-04",
    "folder": "Fushimi Inari Taisha",
    "source": "images/Fushimi Inari Taisha/Untitled 14.png",
    "width": 720,
    "height": 480,
    "aspectRatio": 1.5,
    "alt": "Fushimi Inari Taisha, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/fushimi-inari-taisha/image-04-480.webp",
        "avif": "/media/fushimi-inari-taisha/image-04-480.avif"
      },
      {
        "width": 720,
        "webp": "/media/fushimi-inari-taisha/image-04-720.webp",
        "avif": "/media/fushimi-inari-taisha/image-04-720.avif"
      }
    ]
  },
  {
    "id": "ginza-01",
    "folder": "Ginza",
    "source": "images/Ginza/Untitled 21.png",
    "width": 1288,
    "height": 860,
    "aspectRatio": 1.4977,
    "alt": "Ginza, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/ginza/image-01-480.webp",
        "avif": "/media/ginza/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/ginza/image-01-960.webp",
        "avif": "/media/ginza/image-01-960.avif"
      },
      {
        "width": 1288,
        "webp": "/media/ginza/image-01-1288.webp",
        "avif": "/media/ginza/image-01-1288.avif"
      }
    ]
  },
  {
    "id": "ginza-02",
    "folder": "Ginza",
    "source": "images/Ginza/Untitled 22.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Ginza, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/ginza/image-02-480.webp",
        "avif": "/media/ginza/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/ginza/image-02-960.webp",
        "avif": "/media/ginza/image-02-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/ginza/image-02-1290.webp",
        "avif": "/media/ginza/image-02-1290.avif"
      }
    ]
  },
  {
    "id": "ginza-03",
    "folder": "Ginza",
    "source": "images/Ginza/Untitled 23.png",
    "width": 750,
    "height": 536,
    "aspectRatio": 1.3993,
    "alt": "Ginza, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/ginza/image-03-480.webp",
        "avif": "/media/ginza/image-03-480.avif"
      },
      {
        "width": 750,
        "webp": "/media/ginza/image-03-750.webp",
        "avif": "/media/ginza/image-03-750.avif"
      }
    ]
  },
  {
    "id": "ginza-04",
    "folder": "Ginza",
    "source": "images/Ginza/Untitled 24.png",
    "width": 1289,
    "height": 860,
    "aspectRatio": 1.4988,
    "alt": "Ginza, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/ginza/image-04-480.webp",
        "avif": "/media/ginza/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/ginza/image-04-960.webp",
        "avif": "/media/ginza/image-04-960.avif"
      },
      {
        "width": 1289,
        "webp": "/media/ginza/image-04-1289.webp",
        "avif": "/media/ginza/image-04-1289.avif"
      }
    ]
  },
  {
    "id": "ginza-05",
    "folder": "Ginza",
    "source": "images/Ginza/Untitled 25.png",
    "width": 800,
    "height": 533,
    "aspectRatio": 1.5009,
    "alt": "Ginza, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/ginza/image-05-480.webp",
        "avif": "/media/ginza/image-05-480.avif"
      },
      {
        "width": 800,
        "webp": "/media/ginza/image-05-800.webp",
        "avif": "/media/ginza/image-05-800.avif"
      }
    ]
  },
  {
    "id": "gion-01",
    "folder": "Gion",
    "source": "images/Gion/Untitled 6.png",
    "width": 1291,
    "height": 860,
    "aspectRatio": 1.5012,
    "alt": "Gion, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/gion/image-01-480.webp",
        "avif": "/media/gion/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/gion/image-01-960.webp",
        "avif": "/media/gion/image-01-960.avif"
      },
      {
        "width": 1291,
        "webp": "/media/gion/image-01-1291.webp",
        "avif": "/media/gion/image-01-1291.avif"
      }
    ]
  },
  {
    "id": "gion-02",
    "folder": "Gion",
    "source": "images/Gion/Untitled 7.png",
    "width": 1344,
    "height": 860,
    "aspectRatio": 1.5628,
    "alt": "Gion, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/gion/image-02-480.webp",
        "avif": "/media/gion/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/gion/image-02-960.webp",
        "avif": "/media/gion/image-02-960.avif"
      },
      {
        "width": 1344,
        "webp": "/media/gion/image-02-1344.webp",
        "avif": "/media/gion/image-02-1344.avif"
      }
    ]
  },
  {
    "id": "gion-03",
    "folder": "Gion",
    "source": "images/Gion/Untitled 8.png",
    "width": 1200,
    "height": 800,
    "aspectRatio": 1.5,
    "alt": "Gion, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/gion/image-03-480.webp",
        "avif": "/media/gion/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/gion/image-03-960.webp",
        "avif": "/media/gion/image-03-960.avif"
      },
      {
        "width": 1200,
        "webp": "/media/gion/image-03-1200.webp",
        "avif": "/media/gion/image-03-1200.avif"
      }
    ]
  },
  {
    "id": "gion-04",
    "folder": "Gion",
    "source": "images/Gion/Untitled 9.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Gion, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/gion/image-04-480.webp",
        "avif": "/media/gion/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/gion/image-04-960.webp",
        "avif": "/media/gion/image-04-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/gion/image-04-1290.webp",
        "avif": "/media/gion/image-04-1290.avif"
      }
    ]
  },
  {
    "id": "gion-05",
    "folder": "Gion",
    "source": "images/Gion/Untitled 10.png",
    "width": 600,
    "height": 400,
    "aspectRatio": 1.5,
    "alt": "Gion, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/gion/image-05-480.webp",
        "avif": "/media/gion/image-05-480.avif"
      },
      {
        "width": 600,
        "webp": "/media/gion/image-05-600.webp",
        "avif": "/media/gion/image-05-600.avif"
      }
    ]
  },
  {
    "id": "gion-corner-01",
    "folder": "Gion Corner",
    "source": "images/Gion Corner/Untitled 2.png",
    "width": 348,
    "height": 348,
    "aspectRatio": 1,
    "alt": "Gion Corner, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 348,
        "webp": "/media/gion-corner/image-01-348.webp",
        "avif": "/media/gion-corner/image-01-348.avif"
      }
    ]
  },
  {
    "id": "gion-corner-02",
    "folder": "Gion Corner",
    "source": "images/Gion Corner/Untitled 3.png",
    "width": 660,
    "height": 880,
    "aspectRatio": 0.75,
    "alt": "Gion Corner, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/gion-corner/image-02-480.webp",
        "avif": "/media/gion-corner/image-02-480.avif"
      },
      {
        "width": 660,
        "webp": "/media/gion-corner/image-02-660.webp",
        "avif": "/media/gion-corner/image-02-660.avif"
      }
    ]
  },
  {
    "id": "gion-corner-03",
    "folder": "Gion Corner",
    "source": "images/Gion Corner/Untitled 4.png",
    "width": 1147,
    "height": 860,
    "aspectRatio": 1.3337,
    "alt": "Gion Corner, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/gion-corner/image-03-480.webp",
        "avif": "/media/gion-corner/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/gion-corner/image-03-960.webp",
        "avif": "/media/gion-corner/image-03-960.avif"
      },
      {
        "width": 1147,
        "webp": "/media/gion-corner/image-03-1147.webp",
        "avif": "/media/gion-corner/image-03-1147.avif"
      }
    ]
  },
  {
    "id": "gion-corner-04",
    "folder": "Gion Corner",
    "source": "images/Gion Corner/Untitled.png",
    "width": 1024,
    "height": 1280,
    "aspectRatio": 0.8,
    "alt": "Gion Corner, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/gion-corner/image-04-480.webp",
        "avif": "/media/gion-corner/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/gion-corner/image-04-960.webp",
        "avif": "/media/gion-corner/image-04-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/gion-corner/image-04-1024.webp",
        "avif": "/media/gion-corner/image-04-1024.avif"
      }
    ]
  },
  {
    "id": "harajuku-meiji-jingu-area-01",
    "folder": "Harajuku : Meiji Jingu Area",
    "source": "images/Harajuku : Meiji Jingu Area/Untitled 16.png",
    "width": 380,
    "height": 380,
    "aspectRatio": 1,
    "alt": "Harajuku — Meiji Jingu Area, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 380,
        "webp": "/media/harajuku-meiji-jingu-area/image-01-380.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-01-380.avif"
      }
    ]
  },
  {
    "id": "harajuku-meiji-jingu-area-02",
    "folder": "Harajuku : Meiji Jingu Area",
    "source": "images/Harajuku : Meiji Jingu Area/Untitled 17.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Harajuku — Meiji Jingu Area, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/harajuku-meiji-jingu-area/image-02-480.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/harajuku-meiji-jingu-area/image-02-960.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-02-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/harajuku-meiji-jingu-area/image-02-1290.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-02-1290.avif"
      }
    ]
  },
  {
    "id": "harajuku-meiji-jingu-area-03",
    "folder": "Harajuku : Meiji Jingu Area",
    "source": "images/Harajuku : Meiji Jingu Area/Untitled 18.png",
    "width": 1289,
    "height": 860,
    "aspectRatio": 1.4988,
    "alt": "Harajuku — Meiji Jingu Area, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/harajuku-meiji-jingu-area/image-03-480.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/harajuku-meiji-jingu-area/image-03-960.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-03-960.avif"
      },
      {
        "width": 1289,
        "webp": "/media/harajuku-meiji-jingu-area/image-03-1289.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-03-1289.avif"
      }
    ]
  },
  {
    "id": "harajuku-meiji-jingu-area-04",
    "folder": "Harajuku : Meiji Jingu Area",
    "source": "images/Harajuku : Meiji Jingu Area/Untitled 19.png",
    "width": 1237,
    "height": 860,
    "aspectRatio": 1.4384,
    "alt": "Harajuku — Meiji Jingu Area, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/harajuku-meiji-jingu-area/image-04-480.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/harajuku-meiji-jingu-area/image-04-960.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-04-960.avif"
      },
      {
        "width": 1237,
        "webp": "/media/harajuku-meiji-jingu-area/image-04-1237.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-04-1237.avif"
      }
    ]
  },
  {
    "id": "harajuku-meiji-jingu-area-05",
    "folder": "Harajuku : Meiji Jingu Area",
    "source": "images/Harajuku : Meiji Jingu Area/Untitled 20.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Harajuku — Meiji Jingu Area, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/harajuku-meiji-jingu-area/image-05-480.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-05-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/harajuku-meiji-jingu-area/image-05-960.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-05-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/harajuku-meiji-jingu-area/image-05-1290.webp",
        "avif": "/media/harajuku-meiji-jingu-area/image-05-1290.avif"
      }
    ]
  },
  {
    "id": "kinkaku-ji-golden-pavilion-01",
    "folder": "Kinkaku-ji (Golden Pavilion)",
    "source": "images/Kinkaku-ji (Golden Pavilion)/Untitled 10.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Kinkaku-ji (Golden Pavilion), Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-01-480.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-01-960.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-01-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-01-1290.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-01-1290.avif"
      }
    ]
  },
  {
    "id": "kinkaku-ji-golden-pavilion-02",
    "folder": "Kinkaku-ji (Golden Pavilion)",
    "source": "images/Kinkaku-ji (Golden Pavilion)/Untitled 12.png",
    "width": 800,
    "height": 1200,
    "aspectRatio": 0.6667,
    "alt": "Kinkaku-ji (Golden Pavilion), Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-02-480.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-02-480.avif"
      },
      {
        "width": 800,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-02-800.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-02-800.avif"
      }
    ]
  },
  {
    "id": "kinkaku-ji-golden-pavilion-03",
    "folder": "Kinkaku-ji (Golden Pavilion)",
    "source": "images/Kinkaku-ji (Golden Pavilion)/Untitled 13.png",
    "width": 1147,
    "height": 860,
    "aspectRatio": 1.3337,
    "alt": "Kinkaku-ji (Golden Pavilion), Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-03-480.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-03-960.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-03-960.avif"
      },
      {
        "width": 1147,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-03-1147.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-03-1147.avif"
      }
    ]
  },
  {
    "id": "kinkaku-ji-golden-pavilion-04",
    "folder": "Kinkaku-ji (Golden Pavilion)",
    "source": "images/Kinkaku-ji (Golden Pavilion)/Untitled 14.png",
    "width": 768,
    "height": 1024,
    "aspectRatio": 0.75,
    "alt": "Kinkaku-ji (Golden Pavilion), Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-04-480.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-04-480.avif"
      },
      {
        "width": 768,
        "webp": "/media/kinkaku-ji-golden-pavilion/image-04-768.webp",
        "avif": "/media/kinkaku-ji-golden-pavilion/image-04-768.avif"
      }
    ]
  },
  {
    "id": "kiyomizu-dera-higashiyama-01",
    "folder": "Kiyomizu-dera & Higashiyama",
    "source": "images/Kiyomizu-dera & Higashiyama/Untitled 2.png",
    "width": 1289,
    "height": 860,
    "aspectRatio": 1.4988,
    "alt": "Kiyomizu-dera and Higashiyama, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/kiyomizu-dera-higashiyama/image-01-480.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/kiyomizu-dera-higashiyama/image-01-960.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-01-960.avif"
      },
      {
        "width": 1289,
        "webp": "/media/kiyomizu-dera-higashiyama/image-01-1289.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-01-1289.avif"
      }
    ]
  },
  {
    "id": "kiyomizu-dera-higashiyama-02",
    "folder": "Kiyomizu-dera & Higashiyama",
    "source": "images/Kiyomizu-dera & Higashiyama/Untitled 3.png",
    "width": 1024,
    "height": 1399,
    "aspectRatio": 0.732,
    "alt": "Kiyomizu-dera and Higashiyama, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/kiyomizu-dera-higashiyama/image-02-480.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/kiyomizu-dera-higashiyama/image-02-960.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-02-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/kiyomizu-dera-higashiyama/image-02-1024.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-02-1024.avif"
      }
    ]
  },
  {
    "id": "kiyomizu-dera-higashiyama-03",
    "folder": "Kiyomizu-dera & Higashiyama",
    "source": "images/Kiyomizu-dera & Higashiyama/Untitled 4.png",
    "width": 1291,
    "height": 860,
    "aspectRatio": 1.5012,
    "alt": "Kiyomizu-dera and Higashiyama, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/kiyomizu-dera-higashiyama/image-03-480.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/kiyomizu-dera-higashiyama/image-03-960.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-03-960.avif"
      },
      {
        "width": 1291,
        "webp": "/media/kiyomizu-dera-higashiyama/image-03-1291.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-03-1291.avif"
      }
    ]
  },
  {
    "id": "kiyomizu-dera-higashiyama-04",
    "folder": "Kiyomizu-dera & Higashiyama",
    "source": "images/Kiyomizu-dera & Higashiyama/Untitled 5.png",
    "width": 700,
    "height": 467,
    "aspectRatio": 1.4989,
    "alt": "Kiyomizu-dera and Higashiyama, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/kiyomizu-dera-higashiyama/image-04-480.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-04-480.avif"
      },
      {
        "width": 700,
        "webp": "/media/kiyomizu-dera-higashiyama/image-04-700.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-04-700.avif"
      }
    ]
  },
  {
    "id": "kiyomizu-dera-higashiyama-05",
    "folder": "Kiyomizu-dera & Higashiyama",
    "source": "images/Kiyomizu-dera & Higashiyama/Untitled.png",
    "width": 800,
    "height": 640,
    "aspectRatio": 1.25,
    "alt": "Kiyomizu-dera and Higashiyama, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/kiyomizu-dera-higashiyama/image-05-480.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-05-480.avif"
      },
      {
        "width": 800,
        "webp": "/media/kiyomizu-dera-higashiyama/image-05-800.webp",
        "avif": "/media/kiyomizu-dera-higashiyama/image-05-800.avif"
      }
    ]
  },
  {
    "id": "nishiki-market-01",
    "folder": "Nishiki Market",
    "source": "images/Nishiki Market/Untitled 15.png",
    "width": 800,
    "height": 530,
    "aspectRatio": 1.5094,
    "alt": "Nishiki Market, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/nishiki-market/image-01-480.webp",
        "avif": "/media/nishiki-market/image-01-480.avif"
      },
      {
        "width": 800,
        "webp": "/media/nishiki-market/image-01-800.webp",
        "avif": "/media/nishiki-market/image-01-800.avif"
      }
    ]
  },
  {
    "id": "nishiki-market-02",
    "folder": "Nishiki Market",
    "source": "images/Nishiki Market/Untitled 16.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Nishiki Market, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/nishiki-market/image-02-480.webp",
        "avif": "/media/nishiki-market/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/nishiki-market/image-02-960.webp",
        "avif": "/media/nishiki-market/image-02-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/nishiki-market/image-02-1290.webp",
        "avif": "/media/nishiki-market/image-02-1290.avif"
      }
    ]
  },
  {
    "id": "nishiki-market-03",
    "folder": "Nishiki Market",
    "source": "images/Nishiki Market/Untitled 17.png",
    "width": 683,
    "height": 1024,
    "aspectRatio": 0.667,
    "alt": "Nishiki Market, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/nishiki-market/image-03-480.webp",
        "avif": "/media/nishiki-market/image-03-480.avif"
      },
      {
        "width": 683,
        "webp": "/media/nishiki-market/image-03-683.webp",
        "avif": "/media/nishiki-market/image-03-683.avif"
      }
    ]
  },
  {
    "id": "nohga-hotel-kiyomizu-kyoto-01",
    "folder": "Nohga Hotel Kiyomizu Kyoto",
    "source": "images/Nohga Hotel Kiyomizu Kyoto/Untitled 2.png",
    "width": 1289,
    "height": 860,
    "aspectRatio": 1.4988,
    "alt": "Nohga Hotel Kiyomizu Kyoto, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-01-480.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-01-960.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-01-960.avif"
      },
      {
        "width": 1289,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-01-1289.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-01-1289.avif"
      }
    ]
  },
  {
    "id": "nohga-hotel-kiyomizu-kyoto-02",
    "folder": "Nohga Hotel Kiyomizu Kyoto",
    "source": "images/Nohga Hotel Kiyomizu Kyoto/Untitled 3.png",
    "width": 800,
    "height": 533,
    "aspectRatio": 1.5009,
    "alt": "Nohga Hotel Kiyomizu Kyoto, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-02-480.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-02-480.avif"
      },
      {
        "width": 800,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-02-800.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-02-800.avif"
      }
    ]
  },
  {
    "id": "nohga-hotel-kiyomizu-kyoto-03",
    "folder": "Nohga Hotel Kiyomizu Kyoto",
    "source": "images/Nohga Hotel Kiyomizu Kyoto/Untitled 4.png",
    "width": 1147,
    "height": 860,
    "aspectRatio": 1.3337,
    "alt": "Nohga Hotel Kiyomizu Kyoto, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-03-480.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-03-960.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-03-960.avif"
      },
      {
        "width": 1147,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-03-1147.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-03-1147.avif"
      }
    ]
  },
  {
    "id": "nohga-hotel-kiyomizu-kyoto-04",
    "folder": "Nohga Hotel Kiyomizu Kyoto",
    "source": "images/Nohga Hotel Kiyomizu Kyoto/Untitled 5.png",
    "width": 1147,
    "height": 860,
    "aspectRatio": 1.3337,
    "alt": "Nohga Hotel Kiyomizu Kyoto, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-04-480.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-04-960.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-04-960.avif"
      },
      {
        "width": 1147,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-04-1147.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-04-1147.avif"
      }
    ]
  },
  {
    "id": "nohga-hotel-kiyomizu-kyoto-05",
    "folder": "Nohga Hotel Kiyomizu Kyoto",
    "source": "images/Nohga Hotel Kiyomizu Kyoto/Untitled.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Nohga Hotel Kiyomizu Kyoto, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-05-480.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-05-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-05-960.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-05-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/nohga-hotel-kiyomizu-kyoto/image-05-1290.webp",
        "avif": "/media/nohga-hotel-kiyomizu-kyoto/image-05-1290.avif"
      }
    ]
  },
  {
    "id": "optional-stops-01",
    "folder": "Optional Stops",
    "source": "images/Optional Stops/Untitled 2.png",
    "width": 840,
    "height": 560,
    "aspectRatio": 1.5,
    "alt": "Optional Stops, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/optional-stops/image-01-480.webp",
        "avif": "/media/optional-stops/image-01-480.avif"
      },
      {
        "width": 840,
        "webp": "/media/optional-stops/image-01-840.webp",
        "avif": "/media/optional-stops/image-01-840.avif"
      }
    ]
  },
  {
    "id": "optional-stops-02",
    "folder": "Optional Stops",
    "source": "images/Optional Stops/Untitled 3.png",
    "width": 750,
    "height": 536,
    "aspectRatio": 1.3993,
    "alt": "Optional Stops, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/optional-stops/image-02-480.webp",
        "avif": "/media/optional-stops/image-02-480.avif"
      },
      {
        "width": 750,
        "webp": "/media/optional-stops/image-02-750.webp",
        "avif": "/media/optional-stops/image-02-750.avif"
      }
    ]
  },
  {
    "id": "optional-stops-03",
    "folder": "Optional Stops",
    "source": "images/Optional Stops/Untitled 4.png",
    "width": 1147,
    "height": 860,
    "aspectRatio": 1.3337,
    "alt": "Optional Stops, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/optional-stops/image-03-480.webp",
        "avif": "/media/optional-stops/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/optional-stops/image-03-960.webp",
        "avif": "/media/optional-stops/image-03-960.avif"
      },
      {
        "width": 1147,
        "webp": "/media/optional-stops/image-03-1147.webp",
        "avif": "/media/optional-stops/image-03-1147.avif"
      }
    ]
  },
  {
    "id": "optional-stops-04",
    "folder": "Optional Stops",
    "source": "images/Optional Stops/Untitled 5.png",
    "width": 1000,
    "height": 666,
    "aspectRatio": 1.5015,
    "alt": "Optional Stops, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/optional-stops/image-04-480.webp",
        "avif": "/media/optional-stops/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/optional-stops/image-04-960.webp",
        "avif": "/media/optional-stops/image-04-960.avif"
      },
      {
        "width": 1000,
        "webp": "/media/optional-stops/image-04-1000.webp",
        "avif": "/media/optional-stops/image-04-1000.avif"
      }
    ]
  },
  {
    "id": "optional-stops-05",
    "folder": "Optional Stops",
    "source": "images/Optional Stops/Untitled.png",
    "width": 1287,
    "height": 860,
    "aspectRatio": 1.4965,
    "alt": "Optional Stops, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/optional-stops/image-05-480.webp",
        "avif": "/media/optional-stops/image-05-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/optional-stops/image-05-960.webp",
        "avif": "/media/optional-stops/image-05-960.avif"
      },
      {
        "width": 1287,
        "webp": "/media/optional-stops/image-05-1287.webp",
        "avif": "/media/optional-stops/image-05-1287.avif"
      }
    ]
  },
  {
    "id": "otemachi-hoshinoya-tokyo-01",
    "folder": "Otemachi : Hoshinoya Tokyo",
    "source": "images/Otemachi : Hoshinoya Tokyo/Untitled 2.png",
    "width": 1024,
    "height": 1365,
    "aspectRatio": 0.7502,
    "alt": "Otemachi — Hoshinoya Tokyo, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-01-480.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-01-960.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-01-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-01-1024.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-01-1024.avif"
      }
    ]
  },
  {
    "id": "otemachi-hoshinoya-tokyo-02",
    "folder": "Otemachi : Hoshinoya Tokyo",
    "source": "images/Otemachi : Hoshinoya Tokyo/Untitled 3.png",
    "width": 1200,
    "height": 557,
    "aspectRatio": 2.1544,
    "alt": "Otemachi — Hoshinoya Tokyo, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-02-480.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-02-960.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-02-960.avif"
      },
      {
        "width": 1200,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-02-1200.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-02-1200.avif"
      }
    ]
  },
  {
    "id": "otemachi-hoshinoya-tokyo-03",
    "folder": "Otemachi : Hoshinoya Tokyo",
    "source": "images/Otemachi : Hoshinoya Tokyo/Untitled 4.png",
    "width": 806,
    "height": 605,
    "aspectRatio": 1.3322,
    "alt": "Otemachi — Hoshinoya Tokyo, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-03-480.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-03-480.avif"
      },
      {
        "width": 806,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-03-806.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-03-806.avif"
      }
    ]
  },
  {
    "id": "otemachi-hoshinoya-tokyo-04",
    "folder": "Otemachi : Hoshinoya Tokyo",
    "source": "images/Otemachi : Hoshinoya Tokyo/Untitled 5.png",
    "width": 1289,
    "height": 860,
    "aspectRatio": 1.4988,
    "alt": "Otemachi — Hoshinoya Tokyo, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-04-480.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-04-960.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-04-960.avif"
      },
      {
        "width": 1289,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-04-1289.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-04-1289.avif"
      }
    ]
  },
  {
    "id": "otemachi-hoshinoya-tokyo-05",
    "folder": "Otemachi : Hoshinoya Tokyo",
    "source": "images/Otemachi : Hoshinoya Tokyo/Untitled.png",
    "width": 1024,
    "height": 1024,
    "aspectRatio": 1,
    "alt": "Otemachi — Hoshinoya Tokyo, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-05-480.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-05-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-05-960.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-05-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/otemachi-hoshinoya-tokyo/image-05-1024.webp",
        "avif": "/media/otemachi-hoshinoya-tokyo/image-05-1024.avif"
      }
    ]
  },
  {
    "id": "scenic-inter-city-travel-01",
    "folder": "Scenic Inter-city Travel",
    "source": "images/Scenic Inter-city Travel/Untitled 6.png",
    "width": 1147,
    "height": 860,
    "aspectRatio": 1.3337,
    "alt": "Scenic Inter-city Travel, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/scenic-inter-city-travel/image-01-480.webp",
        "avif": "/media/scenic-inter-city-travel/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/scenic-inter-city-travel/image-01-960.webp",
        "avif": "/media/scenic-inter-city-travel/image-01-960.avif"
      },
      {
        "width": 1147,
        "webp": "/media/scenic-inter-city-travel/image-01-1147.webp",
        "avif": "/media/scenic-inter-city-travel/image-01-1147.avif"
      }
    ]
  },
  {
    "id": "scenic-inter-city-travel-02",
    "folder": "Scenic Inter-city Travel",
    "source": "images/Scenic Inter-city Travel/Untitled 7.png",
    "width": 1000,
    "height": 667,
    "aspectRatio": 1.4993,
    "alt": "Scenic Inter-city Travel, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/scenic-inter-city-travel/image-02-480.webp",
        "avif": "/media/scenic-inter-city-travel/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/scenic-inter-city-travel/image-02-960.webp",
        "avif": "/media/scenic-inter-city-travel/image-02-960.avif"
      },
      {
        "width": 1000,
        "webp": "/media/scenic-inter-city-travel/image-02-1000.webp",
        "avif": "/media/scenic-inter-city-travel/image-02-1000.avif"
      }
    ]
  },
  {
    "id": "scenic-inter-city-travel-03",
    "folder": "Scenic Inter-city Travel",
    "source": "images/Scenic Inter-city Travel/Untitled 8.png",
    "width": 1024,
    "height": 1365,
    "aspectRatio": 0.7502,
    "alt": "Scenic Inter-city Travel, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/scenic-inter-city-travel/image-03-480.webp",
        "avif": "/media/scenic-inter-city-travel/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/scenic-inter-city-travel/image-03-960.webp",
        "avif": "/media/scenic-inter-city-travel/image-03-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/scenic-inter-city-travel/image-03-1024.webp",
        "avif": "/media/scenic-inter-city-travel/image-03-1024.avif"
      }
    ]
  },
  {
    "id": "scenic-inter-city-travel-04",
    "folder": "Scenic Inter-city Travel",
    "source": "images/Scenic Inter-city Travel/Untitled 9.png",
    "width": 1280,
    "height": 800,
    "aspectRatio": 1.6,
    "alt": "Scenic Inter-city Travel, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/scenic-inter-city-travel/image-04-480.webp",
        "avif": "/media/scenic-inter-city-travel/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/scenic-inter-city-travel/image-04-960.webp",
        "avif": "/media/scenic-inter-city-travel/image-04-960.avif"
      },
      {
        "width": 1280,
        "webp": "/media/scenic-inter-city-travel/image-04-1280.webp",
        "avif": "/media/scenic-inter-city-travel/image-04-1280.avif"
      }
    ]
  },
  {
    "id": "scenic-inter-city-travel-05",
    "folder": "Scenic Inter-city Travel",
    "source": "images/Scenic Inter-city Travel/Untitled 10.png",
    "width": 650,
    "height": 450,
    "aspectRatio": 1.4444,
    "alt": "Scenic Inter-city Travel, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/scenic-inter-city-travel/image-05-480.webp",
        "avif": "/media/scenic-inter-city-travel/image-05-480.avif"
      },
      {
        "width": 650,
        "webp": "/media/scenic-inter-city-travel/image-05-650.webp",
        "avif": "/media/scenic-inter-city-travel/image-05-650.avif"
      }
    ]
  },
  {
    "id": "sensoji-temple-asakusa-01",
    "folder": "Sensoji Temple & Asakusa",
    "source": "images/Sensoji Temple & Asakusa/Untitled 6.png",
    "width": 1024,
    "height": 682,
    "aspectRatio": 1.5015,
    "alt": "Sensoji Temple and Asakusa, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/sensoji-temple-asakusa/image-01-480.webp",
        "avif": "/media/sensoji-temple-asakusa/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/sensoji-temple-asakusa/image-01-960.webp",
        "avif": "/media/sensoji-temple-asakusa/image-01-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/sensoji-temple-asakusa/image-01-1024.webp",
        "avif": "/media/sensoji-temple-asakusa/image-01-1024.avif"
      }
    ]
  },
  {
    "id": "sensoji-temple-asakusa-02",
    "folder": "Sensoji Temple & Asakusa",
    "source": "images/Sensoji Temple & Asakusa/Untitled 7.png",
    "width": 1026,
    "height": 770,
    "aspectRatio": 1.3325,
    "alt": "Sensoji Temple and Asakusa, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/sensoji-temple-asakusa/image-02-480.webp",
        "avif": "/media/sensoji-temple-asakusa/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/sensoji-temple-asakusa/image-02-960.webp",
        "avif": "/media/sensoji-temple-asakusa/image-02-960.avif"
      },
      {
        "width": 1026,
        "webp": "/media/sensoji-temple-asakusa/image-02-1026.webp",
        "avif": "/media/sensoji-temple-asakusa/image-02-1026.avif"
      }
    ]
  },
  {
    "id": "sensoji-temple-asakusa-03",
    "folder": "Sensoji Temple & Asakusa",
    "source": "images/Sensoji Temple & Asakusa/Untitled 8.png",
    "width": 750,
    "height": 500,
    "aspectRatio": 1.5,
    "alt": "Sensoji Temple and Asakusa, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/sensoji-temple-asakusa/image-03-480.webp",
        "avif": "/media/sensoji-temple-asakusa/image-03-480.avif"
      },
      {
        "width": 750,
        "webp": "/media/sensoji-temple-asakusa/image-03-750.webp",
        "avif": "/media/sensoji-temple-asakusa/image-03-750.avif"
      }
    ]
  },
  {
    "id": "sensoji-temple-asakusa-04",
    "folder": "Sensoji Temple & Asakusa",
    "source": "images/Sensoji Temple & Asakusa/Untitled 9.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Sensoji Temple and Asakusa, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/sensoji-temple-asakusa/image-04-480.webp",
        "avif": "/media/sensoji-temple-asakusa/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/sensoji-temple-asakusa/image-04-960.webp",
        "avif": "/media/sensoji-temple-asakusa/image-04-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/sensoji-temple-asakusa/image-04-1290.webp",
        "avif": "/media/sensoji-temple-asakusa/image-04-1290.avif"
      }
    ]
  },
  {
    "id": "sensoji-temple-asakusa-05",
    "folder": "Sensoji Temple & Asakusa",
    "source": "images/Sensoji Temple & Asakusa/Untitled 10.png",
    "width": 675,
    "height": 449,
    "aspectRatio": 1.5033,
    "alt": "Sensoji Temple and Asakusa, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/sensoji-temple-asakusa/image-05-480.webp",
        "avif": "/media/sensoji-temple-asakusa/image-05-480.avif"
      },
      {
        "width": 675,
        "webp": "/media/sensoji-temple-asakusa/image-05-675.webp",
        "avif": "/media/sensoji-temple-asakusa/image-05-675.avif"
      }
    ]
  },
  {
    "id": "shibuya-01",
    "folder": "Shibuya",
    "source": "images/Shibuya/Untitled 11.png",
    "width": 921,
    "height": 518,
    "aspectRatio": 1.778,
    "alt": "Shibuya, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/shibuya/image-01-480.webp",
        "avif": "/media/shibuya/image-01-480.avif"
      },
      {
        "width": 921,
        "webp": "/media/shibuya/image-01-921.webp",
        "avif": "/media/shibuya/image-01-921.avif"
      }
    ]
  },
  {
    "id": "shibuya-02",
    "folder": "Shibuya",
    "source": "images/Shibuya/Untitled 12.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Shibuya, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/shibuya/image-02-480.webp",
        "avif": "/media/shibuya/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/shibuya/image-02-960.webp",
        "avif": "/media/shibuya/image-02-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/shibuya/image-02-1290.webp",
        "avif": "/media/shibuya/image-02-1290.avif"
      }
    ]
  },
  {
    "id": "shibuya-03",
    "folder": "Shibuya",
    "source": "images/Shibuya/Untitled 13.png",
    "width": 1147,
    "height": 860,
    "aspectRatio": 1.3337,
    "alt": "Shibuya, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/shibuya/image-03-480.webp",
        "avif": "/media/shibuya/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/shibuya/image-03-960.webp",
        "avif": "/media/shibuya/image-03-960.avif"
      },
      {
        "width": 1147,
        "webp": "/media/shibuya/image-03-1147.webp",
        "avif": "/media/shibuya/image-03-1147.avif"
      }
    ]
  },
  {
    "id": "shibuya-04",
    "folder": "Shibuya",
    "source": "images/Shibuya/Untitled 14.png",
    "width": 1200,
    "height": 800,
    "aspectRatio": 1.5,
    "alt": "Shibuya, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/shibuya/image-04-480.webp",
        "avif": "/media/shibuya/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/shibuya/image-04-960.webp",
        "avif": "/media/shibuya/image-04-960.avif"
      },
      {
        "width": 1200,
        "webp": "/media/shibuya/image-04-1200.webp",
        "avif": "/media/shibuya/image-04-1200.avif"
      }
    ]
  },
  {
    "id": "shibuya-05",
    "folder": "Shibuya",
    "source": "images/Shibuya/Untitled 15.png",
    "width": 1024,
    "height": 1536,
    "aspectRatio": 0.6667,
    "alt": "Shibuya, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/shibuya/image-05-480.webp",
        "avif": "/media/shibuya/image-05-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/shibuya/image-05-960.webp",
        "avif": "/media/shibuya/image-05-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/shibuya/image-05-1024.webp",
        "avif": "/media/shibuya/image-05-1024.avif"
      }
    ]
  },
  {
    "id": "tenzan-no-yu-onsen-01",
    "folder": "Tenzan-no-yu Onsen",
    "source": "images/Tenzan-no-yu Onsen/Untitled 5.png",
    "width": 960,
    "height": 640,
    "aspectRatio": 1.5,
    "alt": "Tenzan-no-yu Onsen, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tenzan-no-yu-onsen/image-01-480.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/tenzan-no-yu-onsen/image-01-960.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-01-960.avif"
      }
    ]
  },
  {
    "id": "tenzan-no-yu-onsen-02",
    "folder": "Tenzan-no-yu Onsen",
    "source": "images/Tenzan-no-yu Onsen/Untitled 6.png",
    "width": 800,
    "height": 600,
    "aspectRatio": 1.3333,
    "alt": "Tenzan-no-yu Onsen, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tenzan-no-yu-onsen/image-02-480.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-02-480.avif"
      },
      {
        "width": 800,
        "webp": "/media/tenzan-no-yu-onsen/image-02-800.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-02-800.avif"
      }
    ]
  },
  {
    "id": "tenzan-no-yu-onsen-03",
    "folder": "Tenzan-no-yu Onsen",
    "source": "images/Tenzan-no-yu Onsen/Untitled 7.png",
    "width": 470,
    "height": 376,
    "aspectRatio": 1.25,
    "alt": "Tenzan-no-yu Onsen, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 470,
        "webp": "/media/tenzan-no-yu-onsen/image-03-470.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-03-470.avif"
      }
    ]
  },
  {
    "id": "tenzan-no-yu-onsen-04",
    "folder": "Tenzan-no-yu Onsen",
    "source": "images/Tenzan-no-yu Onsen/Untitled 8.png",
    "width": 1080,
    "height": 810,
    "aspectRatio": 1.3333,
    "alt": "Tenzan-no-yu Onsen, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tenzan-no-yu-onsen/image-04-480.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/tenzan-no-yu-onsen/image-04-960.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-04-960.avif"
      },
      {
        "width": 1080,
        "webp": "/media/tenzan-no-yu-onsen/image-04-1080.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-04-1080.avif"
      }
    ]
  },
  {
    "id": "tenzan-no-yu-onsen-05",
    "folder": "Tenzan-no-yu Onsen",
    "source": "images/Tenzan-no-yu Onsen/Untitled 9.png",
    "width": 1146,
    "height": 860,
    "aspectRatio": 1.3326,
    "alt": "Tenzan-no-yu Onsen, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tenzan-no-yu-onsen/image-05-480.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-05-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/tenzan-no-yu-onsen/image-05-960.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-05-960.avif"
      },
      {
        "width": 1146,
        "webp": "/media/tenzan-no-yu-onsen/image-05-1146.webp",
        "avif": "/media/tenzan-no-yu-onsen/image-05-1146.avif"
      }
    ]
  },
  {
    "id": "tokyo-skytree-01",
    "folder": "Tokyo Skytree",
    "source": "images/Tokyo Skytree/Untitled 36.png",
    "width": 1000,
    "height": 750,
    "aspectRatio": 1.3333,
    "alt": "Tokyo Skytree, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-skytree/image-01-480.webp",
        "avif": "/media/tokyo-skytree/image-01-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/tokyo-skytree/image-01-960.webp",
        "avif": "/media/tokyo-skytree/image-01-960.avif"
      },
      {
        "width": 1000,
        "webp": "/media/tokyo-skytree/image-01-1000.webp",
        "avif": "/media/tokyo-skytree/image-01-1000.avif"
      }
    ]
  },
  {
    "id": "tokyo-skytree-02",
    "folder": "Tokyo Skytree",
    "source": "images/Tokyo Skytree/Untitled 37.png",
    "width": 1290,
    "height": 860,
    "aspectRatio": 1.5,
    "alt": "Tokyo Skytree, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-skytree/image-02-480.webp",
        "avif": "/media/tokyo-skytree/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/tokyo-skytree/image-02-960.webp",
        "avif": "/media/tokyo-skytree/image-02-960.avif"
      },
      {
        "width": 1290,
        "webp": "/media/tokyo-skytree/image-02-1290.webp",
        "avif": "/media/tokyo-skytree/image-02-1290.avif"
      }
    ]
  },
  {
    "id": "tokyo-skytree-03",
    "folder": "Tokyo Skytree",
    "source": "images/Tokyo Skytree/Untitled 38.png",
    "width": 1147,
    "height": 860,
    "aspectRatio": 1.3337,
    "alt": "Tokyo Skytree, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-skytree/image-03-480.webp",
        "avif": "/media/tokyo-skytree/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/tokyo-skytree/image-03-960.webp",
        "avif": "/media/tokyo-skytree/image-03-960.avif"
      },
      {
        "width": 1147,
        "webp": "/media/tokyo-skytree/image-03-1147.webp",
        "avif": "/media/tokyo-skytree/image-03-1147.avif"
      }
    ]
  },
  {
    "id": "tokyo-skytree-04",
    "folder": "Tokyo Skytree",
    "source": "images/Tokyo Skytree/Untitled 39.png",
    "width": 812,
    "height": 438,
    "aspectRatio": 1.8539,
    "alt": "Tokyo Skytree, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-skytree/image-04-480.webp",
        "avif": "/media/tokyo-skytree/image-04-480.avif"
      },
      {
        "width": 812,
        "webp": "/media/tokyo-skytree/image-04-812.webp",
        "avif": "/media/tokyo-skytree/image-04-812.avif"
      }
    ]
  },
  {
    "id": "tokyo-skytree-05",
    "folder": "Tokyo Skytree",
    "source": "images/Tokyo Skytree/Untitled 40.png",
    "width": 650,
    "height": 487,
    "aspectRatio": 1.3347,
    "alt": "Tokyo Skytree, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-skytree/image-05-480.webp",
        "avif": "/media/tokyo-skytree/image-05-480.avif"
      },
      {
        "width": 650,
        "webp": "/media/tokyo-skytree/image-05-650.webp",
        "avif": "/media/tokyo-skytree/image-05-650.avif"
      }
    ]
  },
  {
    "id": "tokyo-tower-01",
    "folder": "Tokyo Tower",
    "source": "images/Tokyo Tower/Untitled 31.png",
    "width": 736,
    "height": 1288,
    "aspectRatio": 0.5714,
    "alt": "Tokyo Tower, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-tower/image-01-480.webp",
        "avif": "/media/tokyo-tower/image-01-480.avif"
      },
      {
        "width": 736,
        "webp": "/media/tokyo-tower/image-01-736.webp",
        "avif": "/media/tokyo-tower/image-01-736.avif"
      }
    ]
  },
  {
    "id": "tokyo-tower-02",
    "folder": "Tokyo Tower",
    "source": "images/Tokyo Tower/Untitled 32.png",
    "width": 1289,
    "height": 860,
    "aspectRatio": 1.4988,
    "alt": "Tokyo Tower, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-tower/image-02-480.webp",
        "avif": "/media/tokyo-tower/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/tokyo-tower/image-02-960.webp",
        "avif": "/media/tokyo-tower/image-02-960.avif"
      },
      {
        "width": 1289,
        "webp": "/media/tokyo-tower/image-02-1289.webp",
        "avif": "/media/tokyo-tower/image-02-1289.avif"
      }
    ]
  },
  {
    "id": "tokyo-tower-03",
    "folder": "Tokyo Tower",
    "source": "images/Tokyo Tower/Untitled 33.png",
    "width": 620,
    "height": 958,
    "aspectRatio": 0.6472,
    "alt": "Tokyo Tower, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-tower/image-03-480.webp",
        "avif": "/media/tokyo-tower/image-03-480.avif"
      },
      {
        "width": 620,
        "webp": "/media/tokyo-tower/image-03-620.webp",
        "avif": "/media/tokyo-tower/image-03-620.avif"
      }
    ]
  },
  {
    "id": "tokyo-tower-04",
    "folder": "Tokyo Tower",
    "source": "images/Tokyo Tower/Untitled 34.png",
    "width": 1112,
    "height": 860,
    "aspectRatio": 1.293,
    "alt": "Tokyo Tower, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-tower/image-04-480.webp",
        "avif": "/media/tokyo-tower/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/tokyo-tower/image-04-960.webp",
        "avif": "/media/tokyo-tower/image-04-960.avif"
      },
      {
        "width": 1112,
        "webp": "/media/tokyo-tower/image-04-1112.webp",
        "avif": "/media/tokyo-tower/image-04-1112.avif"
      }
    ]
  },
  {
    "id": "tokyo-tower-05",
    "folder": "Tokyo Tower",
    "source": "images/Tokyo Tower/Untitled 35.png",
    "width": 1024,
    "height": 1536,
    "aspectRatio": 0.6667,
    "alt": "Tokyo Tower, Japan — journey photograph 5",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/tokyo-tower/image-05-480.webp",
        "avif": "/media/tokyo-tower/image-05-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/tokyo-tower/image-05-960.webp",
        "avif": "/media/tokyo-tower/image-05-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/tokyo-tower/image-05-1024.webp",
        "avif": "/media/tokyo-tower/image-05-1024.avif"
      }
    ]
  },
  {
    "id": "uji-01",
    "folder": "Uji",
    "source": "images/Uji/Untitled 15.png",
    "width": 820,
    "height": 546,
    "aspectRatio": 1.5018,
    "alt": "Uji, Japan — journey photograph 1",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/uji/image-01-480.webp",
        "avif": "/media/uji/image-01-480.avif"
      },
      {
        "width": 820,
        "webp": "/media/uji/image-01-820.webp",
        "avif": "/media/uji/image-01-820.avif"
      }
    ]
  },
  {
    "id": "uji-02",
    "folder": "Uji",
    "source": "images/Uji/Untitled 16.png",
    "width": 1024,
    "height": 768,
    "aspectRatio": 1.3333,
    "alt": "Uji, Japan — journey photograph 2",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/uji/image-02-480.webp",
        "avif": "/media/uji/image-02-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/uji/image-02-960.webp",
        "avif": "/media/uji/image-02-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/uji/image-02-1024.webp",
        "avif": "/media/uji/image-02-1024.avif"
      }
    ]
  },
  {
    "id": "uji-03",
    "folder": "Uji",
    "source": "images/Uji/Untitled 17.png",
    "width": 1024,
    "height": 768,
    "aspectRatio": 1.3333,
    "alt": "Uji, Japan — journey photograph 3",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/uji/image-03-480.webp",
        "avif": "/media/uji/image-03-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/uji/image-03-960.webp",
        "avif": "/media/uji/image-03-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/uji/image-03-1024.webp",
        "avif": "/media/uji/image-03-1024.avif"
      }
    ]
  },
  {
    "id": "uji-04",
    "folder": "Uji",
    "source": "images/Uji/Untitled 18.png",
    "width": 1024,
    "height": 595,
    "aspectRatio": 1.721,
    "alt": "Uji, Japan — journey photograph 4",
    "focalPoint": {
      "x": 0.5,
      "y": 0.5
    },
    "variants": [
      {
        "width": 480,
        "webp": "/media/uji/image-04-480.webp",
        "avif": "/media/uji/image-04-480.avif"
      },
      {
        "width": 960,
        "webp": "/media/uji/image-04-960.webp",
        "avif": "/media/uji/image-04-960.avif"
      },
      {
        "width": 1024,
        "webp": "/media/uji/image-04-1024.webp",
        "avif": "/media/uji/image-04-1024.avif"
      }
    ]
  }
] as const satisfies readonly MediaAsset[]

export const mediaByFolder = mediaAssets.reduce<Record<string, readonly MediaAsset[]>>((groups, asset) => {
  groups[asset.folder] = [...(groups[asset.folder] ?? []), asset]
  return groups
}, {})
